<template>
  <div v-if="active" class="generation-stop-control" role="status" aria-live="polite">
    <el-button
      class="generation-stop-button"
      type="danger"
      round
      :loading="stopping"
      :disabled="stopping"
      @click="handleStop"
    >
      {{ stopping ? stoppingText : stopText }}
    </el-button>
  </div>
</template>

<script>
import { EventBus } from '@/utils/eventbus.js'
import {
  GENERATION_STATE_EVENT,
  getGenerationState,
  stopActiveGeneration
} from '@/utils/llmstream'

export default {
  name: 'GenerationStopButton',
  data() {
    return {
      active: false,
      stopping: false
    }
  },
  computed: {
    stopText() {
      return this.$i18n.locale === 'zh' ? '中止生成' : 'Stop generation'
    },
    stoppingText() {
      return this.$i18n.locale === 'zh' ? '正在中止' : 'Stopping'
    }
  },
  created() {
    this.handleStateChange(getGenerationState())
    EventBus.$on(GENERATION_STATE_EVENT, this.handleStateChange)
  },
  beforeDestroy() {
    EventBus.$off(GENERATION_STATE_EVENT, this.handleStateChange)
  },
  methods: {
    handleStateChange(state) {
      this.active = Boolean(state && state.active)
      this.stopping = Boolean(state && state.stopping)
    },
    handleStop() {
      if (this.stopping) {
        return
      }
      stopActiveGeneration().then(stopped => {
        if (stopped) {
          this.$message.success(this.$i18n.locale === 'zh' ? '已中止生成' : 'Generation stopped')
        }
      }).catch(error => {
        console.error('stop generation failed', error)
        this.$message.error(this.$i18n.locale === 'zh' ? '中止失败，请稍后重试' : 'Failed to stop generation')
      })
    }
  }
}
</script>

<style scoped>
.generation-stop-control {
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 4000;
  transform: translateX(-50%);
}

.generation-stop-button {
  min-width: 128px;
  box-shadow: 0 8px 24px rgba(245, 108, 108, 0.28);
}

@media (max-width: 767px) {
  .generation-stop-control {
    bottom: 16px;
  }
}
</style>
